import { batchWorkspaceApiConnector } from 'apiConnector/batch-workspace';
import { ofType } from 'redux-observable';
import type { Observable } from 'rxjs';
import { EMPTY } from 'rxjs';
import { catchError, ignoreElements, mergeMap } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';

export interface BulkDeleteFormRequest {
  negotiationIds: readonly string[];
}
export interface BatchFormsBulkDeleteApi {
  bulkDeleteForms(request: BulkDeleteFormRequest): Observable<unknown>;
}

export function deleteFormsEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) =>
    actions$.pipe(
      ofType('BATCH_FORMS_DELETE_REQUESTED'),
      mergeMap(({ formIds }) =>
        batchWorkspaceApiConnector(httpClient)
          .bulkDeleteForms({ negotiationIds: formIds })
          .pipe(
            ignoreElements(),
            catchError(_ => {
              return EMPTY;
            }),
          ),
      ),
    );
}
